var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3H13.7188C13.7188 2.9375 13.75 2.84375 13.75 2.75C13.75 1.8125 12.9375 1 12 1C11.0312 1 10.25 1.8125 10.25 2.75C10.25 2.84375 10.25 2.9375 10.25 3H7.5C6.65625 3 6 3.6875 6 4.5V15.5C6 16.3438 6.65625 17 7.5 17H16.5C17.3125 17 18 16.3438 18 15.5V4.5C18 3.6875 17.3125 3 16.5 3ZM12 2C12.4062 2 12.75 2.34375 12.75 2.75C12.75 3.1875 12.4062 3.5 12 3.5C11.5625 3.5 11.25 3.1875 11.25 2.75C11.25 2.34375 11.5625 2 12 2ZM17 15.5C17 15.7812 16.75 16 16.5 16H7.5C7.21875 16 7 15.7812 7 15.5V4.5C7 4.25 7.21875 4 7.5 4H9V4.625C9 4.84375 9.15625 5 9.375 5H14.625C14.8125 5 15 4.84375 15 4.625V4H16.5C16.75 4 17 4.25 17 4.5V15.5ZM15.1562 8.125C15 7.96875 14.75 7.96875 14.625 8.125L10.9375 11.7812L9.375 10.1875C9.21875 10.0312 8.96875 10.0312 8.84375 10.1875L8.5625 10.4688C8.40625 10.5938 8.40625 10.8438 8.5625 11L10.6562 13.0938C10.8125 13.25 11.0625 13.25 11.1875 13.0938L15.4062 8.9375C15.5625 8.78125 15.5625 8.53125 15.4062 8.40625L15.1562 8.125Z",
    fill: "#6C757D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileCheck);
export default __webpack_public_path__ + "static/media/file-check.4d5e890c.svg";
export { ForwardRef as ReactComponent };